import "./assets/css/style.css";

import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { PartidoProvider } from "./context/PartidoContext";

function App() {
  return (
    <PartidoProvider>
      <RouterProvider router={router} />
    </PartidoProvider>
  );
}

export default App;
